import React, { useState, useEffect } from "react";
import "./navbar.css";
import { motion, AnimatePresence } from "framer-motion";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const menuVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren",
      },
    },
    exit: {
      opacity: 0,
      transition: { duration: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <nav className="navbar">
        <div className="logo-wrapper">
          <img
            src="https://i.imgur.com/1EBXSNB.png"
            alt="Logo"
            className="home-logo"
          />
        </div>

      <ul className={`navbar-links ${isOpen ? "active" : ""}`}>
        <li>
          <NavLink
            to="/"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            HOME
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/story"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            OUR STORY
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/menu"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            MENUS
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/locations"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            LOCATIONS
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/events"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            EVENTS
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/giftcards"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            GIFT CARDS
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/takeaway"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            ORDER ONLINE
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            CONTACT
          </NavLink>
        </li>
      </ul>
      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            className="navbar-links mobile"
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.li variants={itemVariants}>
              <Link to="/" onClick={() => setIsOpen(false)}>
                HOME
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/story" onClick={() => setIsOpen(false)}>
                OUR STORY
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/menu" onClick={() => setIsOpen(false)}>
                MENUS
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/locations" onClick={() => setIsOpen(false)}>
                LOCATIONS
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/giftcards" onClick={() => setIsOpen(false)}>
                GIFT CARDS
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/takeaway" onClick={() => setIsOpen(false)}>
                ORDER ONLINE
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/events" onClick={() => setIsOpen(false)}>
                EVENTS
              </Link>
            </motion.li>
            <motion.li variants={itemVariants}>
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                CONTACT
              </Link>
            </motion.li>
          </motion.ul>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
